/* esm.sh - applesauce-common@5.2.0/dist/helpers/legacy-messages */
export * from "/*applesauce-common@5.2.0/esnext/dist/helpers/legacy-messages.mjs";
